{
	"labels":{
		"ime":"Ime:",
		"priimek":"Priimek:",
		"naslov":"Naslov:",
		"posta":"Pošta:",
		"kraj":"Kraj:",
		"email":"E-mail:",
		"telefon":"Telefon:",
		"klub":"Izberi klub : ",
		"naletJ":"Nalet jadralno :",
		"naletM":"Nalet motorno :",
		"licenca":"Številka licence",
		"instruktor":"Inštruktor (motorno)",
		"instruktorJ":"Inštruktor (jadralno)",
		"instruktorUL": "Inštruktor (ultralight)",
		"vlecniR":"Vlečni rating",
		"opomba":"Opomba",
	    "jadralniP": "Pilot(jadralno)",
	    "motorniP": "Pilot (motorno)",
	    "ultraP": "Pilot (ultralight)"
	},
	"buttons": {
		"vnos": "Vnesi zapis",
		"brisiIzbiro": "Pobriši izbiro"
	}
}